import { render, staticRenderFns } from "./Loadpoint.vue?vue&type=template&id=3306c4b8"
import script from "./Loadpoint.vue?vue&type=script&lang=js"
export * from "./Loadpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports